import { t } from 'i18next';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { replaceExpecialCharacters } from '../../../helpers/helpers';

export const PeopleToVisitSearcher = ({ searchFunction, filters }) => {
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('');

    const handleOnKeyPress = (e) => {
        if ((e.key === 'Enter')) {
            searchFunction({
                ...filters,
                searchText: searchText,
                regFrom: 1
            })
        };
    };

    return (
        <>
            <div className='mt-2 mb-2'>
                <input
                    placeholder={t('SEARCH')}
                    type={"text"}
                    name={'search_text'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={(e) => setSearchText(replaceExpecialCharacters(e.target.value))}
                    onKeyPress={handleOnKeyPress}
                />
            </div>

            <div className='text-end mt-3 mb-3'>
                <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '19px', display: 'inline' }}
                    className='m-0 me-1 gray-950-color'
                    onClick={() => navigate('/settings/entityManagment/peopleToVisitMaganagement/create')}
                    type="button"
                >
                    {`+ ${t('CREATE')} ${t('PERSON_TO_VISIT')}`}
                </p>
            </div>
        </>
    )
}
